import { lowerCase, upperFirst } from 'lodash';
import { RHFMultiSelect, RHFMultiSelectProps } from 'src/components/hook-form';
import { PropertyStatus } from 'src/gql/graphql';

type RHFMultiSelectPropertyStatusFieldProps = Omit<
  RHFMultiSelectProps,
  'options'
>;

export function RHFMultiSelectPropertyStatusField(
  props: RHFMultiSelectPropertyStatusFieldProps
) {
  const items = Object.values(PropertyStatus).map((key) => ({
    value: key,
    label: upperFirst(lowerCase(key)),
  }));

  return <RHFMultiSelect {...props} options={items} />;
}
